import * as actionTypes from "../actions/actionTypes";

const initialState: {} = {
  disputeAuthorizationForm: null,
};
const disputeAuthorizationReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.DISPUTE_AUTHORIZATION_FILE:
      return {
        ...state,
        disputeAuthorizationForm: action.disputeAuthorizationForm,
      };
      case actionTypes.RESET_DISPUTE_AUTHORIZATION_FILE:
        return initialState;
    default:
      return state;
  }
};
export default disputeAuthorizationReducer;
